import ContactPageContent from '../components/Contact/Contact.js';

const ContactPage = () => {
  return <ContactPageContent />;
};

export default ContactPage;
